import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = {
  class: "d-flex justify-content-end",
  "data-kt-subscription-table-toolbar": "base"
}
const _hoisted_7 = { class: "svg-icon svg-icon-2" }
const _hoisted_8 = {
  id: "kt_auction_create_details",
  class: "collapse show"
}
const _hoisted_9 = { class: "card-body border-top p-9" }
const _hoisted_10 = { class: "row mb-6" }
const _hoisted_11 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_12 = { class: "required" }
const _hoisted_13 = { class: "col-lg-8 fv-row" }
const _hoisted_14 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "fv-plugins-message-container" }
const _hoisted_17 = { class: "fv-help-block" }
const _hoisted_18 = { class: "row mb-6" }
const _hoisted_19 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_20 = { class: "required" }
const _hoisted_21 = { class: "col-lg-8 fv-row" }
const _hoisted_22 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "fv-plugins-message-container" }
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_27 = {
  key: 0,
  type: "submit",
  id: "kt_auction_create_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_28 = { class: "indicator-label" }
const _hoisted_29 = { class: "indicator-progress" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('update', 'unsigned-packages'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('shipmentDetails') + ' (' + _ctx.shipment.tracknumber + ')'), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: "/manage/shipments/shipment-listing",
                class: "btn btn-light me-3"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.translate('backToList')), 1)
                ]),
                _: 1
              }),
              (_ctx.can('update', 'unsigned-packages'))
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: `/manage/shipments/shipment-updating/${_ctx.shipment.id}`,
                    class: "btn btn-primary"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_7, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen019.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.translate('changeStatus')), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitUpdate,
            "validation-schema": _ctx.shipmentsSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("label", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.translate('selectOffice')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "officeId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.shipment.officeId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.shipment.officeId) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.translate('selectOffice')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offices, (office) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: office.id,
                            value: office.id
                          }, _toDisplayString(office.name[1].title), 9, _hoisted_15))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_ErrorMessage, { name: "officeId" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.translate('shipmentStatuses')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "statusId",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.shipment.statusId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.shipment.statusId) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_22, _toDisplayString(_ctx.translate('selectStatus')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shipmentStatuses, (shipmentStatus) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: shipmentStatus.id,
                            value: shipmentStatus.id
                          }, _toDisplayString(shipmentStatus.internal[1].title), 9, _hoisted_23))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_ErrorMessage, { name: "statusId" })
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                (_ctx.can('update', 'shipments'))
                  ? (_openBlock(), _createElementBlock("button", _hoisted_27, [
                      _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.translate('saveChanges')), 1),
                      _createElementVNode("span", _hoisted_29, [
                        _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                        _hoisted_30
                      ])
                    ], 512))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}